<template>
  <div class="container">
    <h2 class="mb-4 text-center">Portfolio</h2>
    <div class="row">
      <div class="col-md-4 mb-4" v-for="(project, index) in projects" :key="index">
        <div class="card shadow-sm h-100 custom-card">
          <img :src="project.image" class="card-img-top" :alt="project.title" />
          <div class="card-body text-center">
            <h5 class="card-title">{{ project.title }}</h5>
            <p class="card-text">{{ project.description }}</p>
            <a :href="project.link" target="_blank" class="btn btn-primary btn-sm">View Project</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-card {
  background-color: #f6f6f8ff; /* Light gray */
  
}
</style>

<script>
export default {
  name: "PortfolioPage",
  data() {
    return {
      projects: [
        {
          title: "Emak",
          description: "EMAK is a sales crm software providing the highest level of traceability in sales and marketing activities, clear visibility across crm sales force deployment, distributors and retailers.",
          image: "/images/emak.png",
          link: "#"
        },
        {
          title: "Prompttech Insurance CRM",
          description: "Streamline insurance sales with CRM.Manage leads, boost conversions, close policies.Efficiently track, engage, and grow your business.",
          image: "/images/ptins.png",
          link: "#"
        },
        {
          title: "iWallet360",
          description: "A smart wallet app to securely store policy details. It sends expiry reminders and offers AI chat support for each policy. Manage all your policies in one place with personalized assistance.",
          image: "/images/iwallet.png",
          link: "#"
        },
        {
          title: "MYSHOPME",
          description: "MyShopMe is a B2B e-commerce platform connecting retailers with wholesalers and brands in the UAE. It simplifies product sourcing and order management.",
          image: "/images/myshopme.png",
          link: "https://www.myshopme.com/"
        },
        {
            title:'Rheedea',
            description: 'Journal submission portal and website',
            image: "/images/rheedea.png",
            link: "https://rheedea.in/"

        },
          {
            title:'Veto PSC',
            description: 'Coaching center CMS website',
            image: "/images/veto.png",
            link: "https://vetopsc.com/"

        }
      ]
    };
  }
};
</script>
